import React from 'react';
import styled from 'styled-components';
import SuggestedArticleListItem from './SuggestedArticleListItem';
import { Article } from './types';

const Wrapper = styled.div`
  padding: 15px 0;
`;

const EmptyList = styled.div`
  padding: 20px 24px;
  font-size: 22px;
  line-height: 28px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 2px;
  color: #031C38;
`;

const SuggestedArticles = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
`;

interface Props {
  data: Article[];
}

const SuggestionArticleList = ({data}: Props) => {
  return (
    <Wrapper>
      { data.length < 1 ?
      <EmptyList>
        <span>Great content is</span>
        <span>coming soon!</span>
      </EmptyList>
       : 
        <SuggestedArticles>
          {data.map(article => <SuggestedArticleListItem key={article.id} itemData={article} />)}
        </SuggestedArticles>
       
       }
    </Wrapper>
  );
};

export default SuggestionArticleList;
